import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=a91a3b7c&"
import script from "CJ/components/speedTest/FooterSpeedTest.component?vue&type=script&lang=js&"
export * from "CJ/components/speedTest/FooterSpeedTest.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports